import React from 'react';
import styled from 'styled-components';
import { POSITION } from './AdsSlot';
import dynamic from 'next/dynamic';

const AdsSlot = dynamic(() => import('./AdsSlot'), {
    ssr: false
});

export type Position = 'left' | 'right';

interface Props {
    id: string;
    position: Position;
}

interface ContainerProps {
    $position: Position;
}

const Container = styled.div<ContainerProps>`
    width: 120px;
    position: absolute;
    height: 100%;
    z-index: 1;
    top: 120px;
    max-height: clamp(600px, 1430px, calc(100% - 120px));
    @media (max-height: 685px) {
        top: 20px;
    }
    @media (min-height: 685px) and (max-height: 768px) {
        top: 12%;
    }

    @media (min-width: 1710px) {
        ${({ $position }) => $position || 'left'}: 50%;
        ${({ $position }) => `margin-${$position}: -850px`}
    }
    @media (min-width: 1510px) and (max-width: 1710px) {
        ${({ $position }) => $position || 'left'}: 50%;
        ${({ $position }) => `margin-${$position}: -750px`}
    }
    @media (min-width: 1460px) and (max-width: 1510px) {
        ${({ $position }) => $position || 'left'}: 50%;
        ${({ $position }) => `margin-${$position}: -730px`}
    }
    @media (min-width: 1265px) and (max-width: 1460px) {
        ${({ $position }) => $position || 'left'}: 0.3%;
    }
    @media (max-width: 1265px) {
        display: none;
    }
`;

const AdStickyWrapper = styled.div`
    width: 120px;
    height: 600px;
    background: #f9f9f9;
    position: sticky;
    top: 20px;
`;

const Skyscraper = ({ position, id }: Props): React.JSX.Element => {
    const DESKTOP_MIN_WIDTH = 1265;

    if (!id) return null;

    return (
        <Container $position={position} key={`container-div-sky-mobile-${id}`}>
            <AdStickyWrapper>
                <AdsSlot
                    adTextPosition={POSITION.top}
                    slotId={id}
                    desktopMinWidth={DESKTOP_MIN_WIDTH}
                />
            </AdStickyWrapper>
        </Container>
    );
};

export default Skyscraper;
